module.exports = __webpack_public_path__ + "media/img/img-icon-853f4196188f13dcefbedb2fd14d5eaa.png";